import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { getPlayerFullPhone } from '../../services'
import { PlayerQueryKeys } from '@/modules/manage-player/keys'
import type { GetPlayerFullPhoneResponse } from '@/modules/manage-player/type'

export default function useQueryGetPlayerFullPhone(
	id: string,
	options?: Omit<
		UseQueryOptions<GetPlayerFullPhoneResponse>,
		'queryKey' | 'queryFn'
	>,
) {
	return useQuery({
		queryKey: [PlayerQueryKeys.GetPlayerFullPhone, id],
		queryFn: () => getPlayerFullPhone(id),
		enabled: false,
		...options,
	})
}
